import React, { SyntheticEvent, useEffect, useState } from 'react';
import filtersStyles from '../../Filters.module.scss';
import styles from './PartnersFilter.module.scss';
import { Action, CloseLight, CloseRoundSmall, Input, Magnifier, TreeSelectOptions } from 'esa-ui-library';
import { TreeValueType, searchNestedTree, useStore } from '../../../../../common';
import { cloneDeep, find } from 'lodash';
import { selectPreselectedPartnersOptions } from '../../Filters.helper';
import useFilters from '../../../../../common/hooks/useFilters';

const PartnersFilter = (): JSX.Element => {
	const [{ partners, filters }, dispatch] = useStore();
	const [active, setActive] = useState<TreeValueType[]>([]);
	const [opened, setOpened] = useState<string[]>([]);
	const [openFilter, setOpenFilter] = useState<boolean>(false);
	const [searchTerm, setSearchTerm] = useState<string>('');
	const { onFilter } = useFilters();
	const searchedTree = searchTerm ? searchNestedTree(cloneDeep(partners), searchTerm) : partners;

	const onPartnersChange = (updatePartners: TreeValueType[]) => {
		const updateValues = updatePartners.map((p) => p.value);
		onFilter([{ name: 'partners', value: updateValues.join() }]);
		dispatch('ACTIVE_PARTNERS', updateValues);
	};

	const searchHandler = (val: string) => {
		setSearchTerm(val);
	};

	const clearSearchHandler = () => {
		setSearchTerm('');
	};

	const openFilterHandler = (e: boolean) => {
		setSearchTerm('');
		setOpenFilter(e);
	};

	const onPartnersRemove = (e: SyntheticEvent) => {
		e.stopPropagation();

		onFilter([{ name: 'partners', value: '' }]);
		dispatch('ACTIVE_PARTNERS', []);
	};

	const getActiveLabels = () => {
		const activePartners = partners.filter((p: TreeValueType) => active.some((a) => a.value === p?.value));

		if (active.length && !activePartners.length) return [`${active.length} Subpartner${active.length > 1 ? 's' : ''}`];
		return activePartners.map((a: TreeValueType) => a.label);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels();

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onPartnersRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	useEffect(() => {
		const filter = find(filters, ['name', 'partners'])?.value || '';
		setActive(selectPreselectedPartnersOptions(partners, filter));
		setSearchTerm('');
	}, [filters]);

	return (
		<Action
			label='Partners'
			labelContent={active.length ? getLabelContent() : 'All'}
			select
			className={`${filtersStyles.Filter} 
			${active.length ? filtersStyles.Active : ''} `}
			dataId='partners-filter'
			onDropdownChange={openFilterHandler}
			controlled
			opened={openFilter}
		>
			<section onClick={(e) => e.stopPropagation()}>
				<div className={styles.SearchContainer}>
					<Input type='text' value={searchTerm} onChange={searchHandler} icon={<Magnifier />} small />
					{searchTerm && <CloseRoundSmall className={styles.Clear} onClick={clearSearchHandler} />}
				</div>
				<div className={styles.List}>
					<TreeSelectOptions
						options={searchedTree}
						selected={active}
						opened={opened}
						onChange={onPartnersChange}
						onOpenedChange={setOpened}
					/>
					{searchedTree?.length === 0 && <p className={styles.EmptyList}>No results</p>}
				</div>
			</section>
		</Action>
	);
};

export { PartnersFilter };
